import { useLocation } from 'react-router-dom';
import Modal from '@/components/feedBack/Modal';
import ChangePasswordForm from '@/components/forms/ChangePasswordForm';
import { useStateContext } from '@/contexts/ContextProvider';

export default function MustChangePasswordModal() {
    const { user } = useStateContext();
    const location = useLocation();

    if (location.pathname.startsWith('/onboarding')) return null;
    if (!user?.must_change_password) return null;

    return (
        <Modal
            open={true}
            setOpen={() => {
                /* no-op: modal is non-dismissable until password is changed */
            }}
            title="Définissez votre mot de passe"
            size="md"
            showFooter={false}
        >
            <div className="flex flex-col gap-4">
                <p className="text-sm text-gray-600">
                    Pour des raisons de sécurité, vous devez définir un nouveau mot de passe avant
                    de continuer.
                </p>
                <ChangePasswordForm />
            </div>
        </Modal>
    );
}
